"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceGroupingRecursiveCreate = exports.ServiceGroupingUpdate = exports.ServiceGroupingCreate = exports.ServiceGroupingCustomerTransport = exports.ServiceGrouping = exports.ServiceGroupingQuery = exports.ServiceGroupingStatusLabels = exports.ServiceGroupingStatus = exports.ServiceGroupingStatuses = exports.ServiceGroupingTypeLabels = exports.ServiceGroupingType = exports.ServiceGroupingTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const payment_processing_1 = require("../invoice/payment-processing");
const ContractDetails_1 = require("./ContractDetails");
const InvoiceGrouping_1 = require("./InvoiceGrouping");
const ServiceOrder_1 = require("./ServiceOrder");
const internal_note_1 = require("./internal-note");
exports.ServiceGroupingTypes = ['single', 'finite', 'open-ended'];
exports.ServiceGroupingType = typebox_1.Type.Union(exports.ServiceGroupingTypes.map((type) => typebox_1.Type.Literal(type)));
exports.ServiceGroupingTypeLabels = {
    single: 'Single',
    finite: 'Finite',
    'open-ended': 'Open Ended',
};
exports.ServiceGroupingStatuses = ['pending', 'ongoing', 'closed'];
exports.ServiceGroupingStatus = typebox_1.Type.Union(exports.ServiceGroupingStatuses.map((status) => typebox_1.Type.Literal(status)));
exports.ServiceGroupingStatusLabels = {
    pending: 'Pending',
    ongoing: 'Ongoing',
    closed: 'Closed',
};
exports.ServiceGroupingQuery = typebox_1.Type.Object({
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 100 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    orderBy: typebox_1.Type.Optional(typebox_1.Type.String()),
    reverseSort: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    shallowPopulate: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    onlyActiveGroupings: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.ServiceGrouping = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    type: exports.ServiceGroupingType,
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: exports.ServiceGroupingStatus,
    serviceOrders: typebox_1.Type.Array(ServiceOrder_1.ServiceOrder),
    invoiceGroupings: typebox_1.Type.Array(InvoiceGrouping_1.InvoiceGrouping),
    orderNumber: typebox_1.Type.String(),
    name: typebox_1.Type.String(),
    contractDetails: typebox_1.Type.Optional(ContractDetails_1.ContractDetails),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    customerName: typebox_1.Type.Optional(typebox_1.Type.String()), // Denormalized from Customer
    customerAccountNumber: typebox_1.Type.Optional(typebox_1.Type.String()), // Denormalized from Customer
    customerCompanyName: typebox_1.Type.Optional(typebox_1.Type.String()), // Denormalized from Customer
    internalNotes: typebox_1.Type.Array(internal_note_1.InternalNote),
    autopayEnabled: typebox_1.Type.Boolean(),
    autopayPaymentMethod: typebox_1.Type.Optional(typebox_1.Type.String()),
    autopayProcessor: typebox_1.Type.Optional(payment_processing_1.AutopaySourceProcessorTransport),
    stripeCustomer: typebox_1.Type.Optional(typebox_1.Type.String()),
    /**
     * Optionally override the customer default billing address for this service grouping.
     */
    billingAddress: typebox_1.Type.Optional(common_1.AddressTransport),
    paymentMethod: typebox_1.Type.Optional(common_1.PaymentMethod),
    paymentTerm: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    images: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    metadata: common_1.MetaData,
});
exports.ServiceGroupingCustomerTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.ServiceGrouping, [
        'id',
        'type',
        'description',
        'status',
        'orderNumber',
        'name',
        'contractDetails',
        'customerID',
        'customerName',
        'customerAccountNumber',
        'customerCompanyName',
        'paymentMethod',
        'paymentTerm',
        'metadata',
        'billingAddress',
    ]),
    typebox_1.Type.Object({
        serviceOrders: typebox_1.Type.Array(ServiceOrder_1.ServiceOrderCustomerTransport),
    }),
]);
exports.ServiceGroupingCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServiceGrouping, ['id', 'serviceOrders', 'invoiceGroupings', 'contractDetails', 'metadata', 'orderNumber']),
    typebox_1.Type.Object({
        contractDetails: typebox_1.Type.Optional(ContractDetails_1.ContractDetailsCreate),
    }),
]);
exports.ServiceGroupingUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServiceGrouping, [
        'id',
        'serviceOrders',
        'invoiceGroupings',
        'orderNumber',
        'contractDetails',
        'metadata',
        'autopayPaymentMethod',
        'autopayProcessor',
        'stripeCustomer',
        'billingAddress',
    ]),
    typebox_1.Type.Object({
        contractDetails: ContractDetails_1.ContractDetailsUpdate,
        autopayPaymentMethod: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
        autopayProcessor: typebox_1.Type.Optional((0, common_1.Nullable)(payment_processing_1.AutopaySourceProcessorTransport)),
        stripeCustomer: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
        billingAddress: typebox_1.Type.Optional((0, common_1.Nullable)(common_1.AddressTransport)),
    }),
]));
exports.ServiceGroupingRecursiveCreate = typebox_1.Type.Intersect([
    exports.ServiceGroupingCreate,
    typebox_1.Type.Object({
        serviceOrders: typebox_1.Type.Array(ServiceOrder_1.ServiceOrderCreate),
        contractDetails: typebox_1.Type.Optional(ContractDetails_1.ContractDetailsCreate),
    }),
]);
//# sourceMappingURL=ServiceGrouping.js.map